import { FC, useEffect } from 'react';
import { useLeafletContext } from '@react-leaflet/core';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import * as L from 'leaflet';
import { useFieldSlice } from 'app/containers/Field/slice';
import { useDispatch } from 'react-redux';
import { IDrawnPolygon } from 'app/containers/Field/slice/types';

interface IProps {}

const GeomanDrawPolygon: FC<IProps> = () => {
  const leafletContext = useLeafletContext();
  const { actions: fieldActions } = useFieldSlice();
  const dispatch = useDispatch();

  useEffect(() => {
    const leafletContainer = (leafletContext.layerContainer ||
      leafletContext.map) as any;

    leafletContainer.pm.addControls({
      position: 'topright',
      drawPolygon: true,
      editMode: true,

      drawMarker: false,
      drawCircleMarker: false,
      drawPolyline: false,
      drawRectangle: false,
      drawCircle: false,
      drawText: false,
    });

    const geomanDrawPolygonsLayer = L.layerGroup() as any;
    geomanDrawPolygonsLayer.addTo(leafletContainer);

    leafletContainer.pm.setGlobalOptions({
      pmIgnore: false,
      layerGroup: geomanDrawPolygonsLayer,
      allowSelfIntersection: false,
    });

    const onChange = () => {
      const drawnPolygonsArr: IDrawnPolygon[] = [];
      for (let [id, item] of Object.entries(geomanDrawPolygonsLayer._layers)) {
        const polygon = item as any;
        drawnPolygonsArr.push({
          id,
          latlngs: JSON.parse(JSON.stringify(polygon.getLatLngs())),
        });
      }

      dispatch(fieldActions.setDrawnFieldsArr(drawnPolygonsArr));
    };

    leafletContainer.on('pm:create', (e: any) => {
      if (e.layer && e.layer.pm) {
        const shape = e;
        onChange();
        shape.layer.on('pm:edit', () => {
          onChange();
        });
      }
    });

    leafletContainer.on('pm:remove', () => {
      onChange();
    });

    return () => {
      leafletContainer.pm.removeControls();
      leafletContainer.pm.setGlobalOptions({ pmIgnore: true });
    };
  }, [leafletContext, dispatch, fieldActions]);

  return null;
};

export default GeomanDrawPolygon;
